import Vue from 'vue'
import Router from 'vue-router'
import index from '../pages/index/index.vue'
import about from '../pages/index/about.vue'
import service from '../pages/index/service.vue'
import news from '../pages/index/news.vue'

Vue.use(Router);

const routes = [
  {
    path: '/',
    redirect: '/index'
  },
  {
    path: '/index',
    component: index
  },
  {
    path: '/about',
    component: about
  },
  {
    path: '/service',
    component: service
  },
  {
    path: '/news',
    component: news
  },
]

const router = new Router({
  routes,
  // mode: 'history'
  // scrollBehavior (to, from, savedPosition) {
  //   return { x: 0, y: 0}
  // }
})

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default router